export default __webpack_public_path__ + "static/media/news11.3328be98.jpg";